<template>
    <div>
        <Item v-for="item in items" :key="item.id" :data="item"/>
    </div>
</template>

<script>
    import Item from './Item'

    export default {
        name: 'List',
        props: {
            items: Array
        },
        components: {
            Item: Item
        }
    }
</script>

<style scoped>

</style>